import { legacyPageEntrypoint } from '@atlassian/jira-router-routes-legacy-page-entrypoint/src/entrypoint.tsx';
import { createPageEntryPoint } from '@atlassian/jira-create-route-entry-point/src/index.tsx';
import { globalLayout } from '@atlassian/jira-global-layout/src/index.tsx';
import { createLegacyEntry } from '@atlassian/jira-route-entry/src/createLegacyEntry.tsx';
import { legacyPersonalSettingsAccessTokensRoute } from '@atlassian/jira-router-routes-legacy-personal-settings-access-tokens-routes/src/legacyPersonalSettingsAccessTokensRoute.tsx';
// eslint-disable-next-line jira/import/file-extension-required
import type { JiraLegacyRoute } from '@atlassian/jira-route-types/src/JiraLegacyRoute';
import type { RouteResources } from '@atlassian/react-resource-router';

const pageEntryPoint = createPageEntryPoint({
	main: legacyPageEntrypoint,
});

export const legacyPersonalSettingsAccessTokensRouteEntry: JiraLegacyRoute<RouteResources> =
	createLegacyEntry(legacyPersonalSettingsAccessTokensRoute, () => ({
		layout: globalLayout,
		entryPoint: () => pageEntryPoint,
	}));
